import React, { useState, useEffect, useRef } from 'react'
import { useNavigate } from 'react-router-dom';
import HomeButton from './HomeButton';

function SearchProduct() {
    const [name, setName] = useState('');
    const [sortBy, setSortBy] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(8);
    const [filteredProducts, setFilteredProducts] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [showResults, setShowResults] = useState(false);
    const inputRef = useRef(null); // Референца за input полето
    const searchIconRef = useRef(null); // Референца за иконата за пребарување

    const API_URL = process.env.REACT_APP_API_URL;
    const navigate = useNavigate(); // За навигација до нова компонента

    // Функција за пребарување на продукти
    const handleSearch = async (name) => {
        if (name.length < 3) {
            setFilteredProducts([]);
            setShowResults(false);
            return;
        }

        setLoading(true);
        setError(null);
        try {
            const response = await fetch(`${API_URL}/Item/products?name=${name}&sortBy=${sortBy}&pageNumber=${currentPage}&pageSize=${pageSize}`, {
                method: 'GET',
            });

            const result = await response.json();
            setFilteredProducts(result.data.items);
            setShowResults(true);
        } catch (err) {
            setError('Error fetching products');
        } finally {
            setLoading(false);
        }
    };

    // Функција за навигација до нова компонента со сите резултати
    const handleProductClick = (category, id) => {
        setShowResults(false);
        setName('');
        navigate(`/${category}/${id}`); // Користење на navigate() наместо navigate.push()
    };

    // Функција за чистење на инпутот
    const clearInput = () => {
        setName('');
        setFilteredProducts([]);
        setShowResults(false);
    };

    // Функција која се активира на кликање на search иконата
    const handleSearchIconClick = () => {
        if (name.length < 3) {
            return;
        }
        setName('');
        setShowResults(false);
        navigate(`/searchProducts?query=${name}`); // Пренасочување на нова компонента за сите продукти
    };

    // Пребарување кога се менува текстот во инпутот
    useEffect(() => {
        handleSearch(name);
    }, [name]); // Ова ќе се активира секој пат кога се менува името

    const handleKeyDown = (event) => {
        if (event.key === 'Enter') {
            handleSearchIconClick(); // Повикај ја функцијата ако е притиснат Enter
        }
    };

    const handleClickOutside = (event) => {
        // Проверете дали кликот е надвор од input полето и иконата
        if (
          inputRef.current && !inputRef.current.contains(event.target) && // Ако не е кликнато на input
          searchIconRef.current && !searchIconRef.current.contains(event.target) // Ако не е кликнато на иконата
        ) {
            setName(''); // Ресетирај го searchTerm кога се кликне надвор
        }
      };

      useEffect(() => {
        // Додај event listener за клик на целото тело на документот
        document.addEventListener('click', handleClickOutside);
    
        // Отстрани го event listener кога компонентата се уништува
        return () => {
          document.removeEventListener('click', handleClickOutside);
        };
      }, []);


    return (
        <div className="w-full flex flex-col sm:flex-row justify-between mb-4">
            <HomeButton />
            <div className="relative w-full">
                {/* Input Field and Search Icon */}
                <div className="flex items-center border border-gray-300 rounded-lg p-[1px] max-w-xs ml-auto mr-1">
                    <input
                        type="text"
                        className="flex-grow p-1 outline-none w-full"
                        placeholder="Пребарувај"
                        value={name}
                        onChange={(e) => setName(e.target.value)} // Активирање на пребарувањето кога се внесува текст
                        onKeyDown={handleKeyDown}
                        ref={inputRef} // Додадете референца за input
                    />
                    {name && (
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 16 16"
                            fill="currentColor"
                            className="h-5 w-5 text-gray-500 cursor-pointer"
                            onClick={clearInput}
                        >
                            <path
                                fillRule="evenodd"
                                d="M11.03 4.97a1 1 0 0 0-1.415 0L8 6.585 5.385 4.97a1 1 0 1 0-1.415 1.415L6.585 8l-2.615 2.615a1 1 0 1 0 1.415 1.415L8 9.415l2.615 2.615a1 1 0 0 0 1.415-1.415L9.415 8l2.615-2.615a1 1 0 0 0 0-1.415z"
                                clipRule="evenodd"
                            />
                        </svg>
                    )}

                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 16 16"
                        fill="currentColor"
                        className="h-5 w-5 text-gray-500 cursor-pointer"
                        onClick={handleSearchIconClick} // Клик на иконата за пребарување
                        ref={searchIconRef} // Додадете референца за иконата
                    >
                        <path
                            fillRule="evenodd"
                            d="M9.965 11.026a5 5 0 1 1 1.06-1.06l2.755 2.754a.75.75 0 1 1-1.06 1.06l-2.755-2.754ZM10.5 7a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Z"
                            clipRule="evenodd"
                        />
                    </svg>

                </div>

                {/* Search Results */}
                {showResults && filteredProducts.length > 0 && (
                    <ul className="absolute top-full left-0 right-0 mt-1 bg-white border border-gray-300 rounded-lg shadow-lg max-h-60 overflow-y-auto z-50 max-w-xs ml-auto mr-1">
                        {filteredProducts.map((product) => (
                            <li
                                key={product.id}
                                className="inline"
                                onClick={() => handleProductClick(product.categoryName, product.id)} // Навигација до новата компонента
                            >
                                <div className='hover:bg-gray-200 cursor-pointer flex px-4 py-2'>
                                    <img src={product.imageLinks ? product.imageLinks[0]?.imageLink : ''} alt={product.categoryName} className='max-w-[70px] max-h-[50px]' />
                                    {product.title}
                                </div>
                            </li>
                        ))}
                    </ul>
                )}

                {/* Message if no results found */}
                {showResults && filteredProducts.length === 0 && (
                    <div className="absolute top-full left-0 right-0 mt-1 bg-white border border-gray-300 rounded-lg shadow-lg max-h-60 overflow-y-auto z-10 max-w-xs ml-auto mr-1">
                        No results found
                    </div>
                )}
            </div>
        </div>
    )
}

export default SearchProduct
